import { Badge } from "reactstrap";
import Flex from "@components/ui-components/flex";
import LoadingButton from "@components/ui-components/loading-button";
import LongNameFormatter from "@components/formatters/long-name-formatter";
import { ROLE_OPTIONS } from "./constants";
import { getStatusBadge } from "@src/utility/helpers/utils";
import size from "lodash/size";

export const decoColumns = ({ handleRowActions }) => {
    const columns = [
        {
            name    : "name",
            selector: row => row.name,
            cell    : row => {
                return <LongNameFormatter content={row.name} max={40} />;
            }
        },
        {
            name    : "email",
            selector: row => row.email
        },
        {
            name    : "phone",
            selector: row => row.phone,
            cell    : row => <p>{row.phone || "-"}</p>
        },
        {
            name    : "role",
            selector: row => row.role,
            cell    : row => {
                return (
                    ROLE_OPTIONS.find(item => item.value === row.role)?.label ||
                    "-"
                );
            }
        },
        {
            name    : "Tags",
            selector: row => row.tags,
            width   : "250px",
            cell    : row => (
                <Flex wrap>
                    {size(row.tags) ? row.tags.map(item => (
                        <Badge color="primary" className="mb-25">
                            {item.name}
                        </Badge>
                    )) : "-"}
                </Flex>
            )
        },
        {
            name    : "status",
            selector: row => row.status,
            cell    : row => {
                return (
                    <Badge color={getStatusBadge(row.status).color}>
                        {getStatusBadge(row.status).title}
                    </Badge>
                );
            }
        },
        {
            name: "Actions",
            cell: row => (
                <>
                    <LoadingButton
                        className="me-1"
                        outline
                        color="info"
                        id={`${row._id}-edit-button`}
                        icon="pencil"
                        onClick={() => handleRowActions(row, "edit")}/>
                    <LoadingButton
                        outline
                        color="danger"
                        id={`${row._id}-edit-delete`}
                        icon="delete"
                        onClick={() => handleRowActions(row, "delete")}/>
                </>
            )
        }
    ];

    return columns;
};
